import React from 'react';
import { SearchFacetType } from 'src/areas/search/components/results/types';
import AppliedFilter from '../applied-filter';
import ClearButton from './clear-button';
import * as S from './styles';
import { AppliedFilter as AppliedFilterType } from './types';

type Props = {
  clearAllFilters: (property?: string) => void;
  filters: AppliedFilterType[];
  onClearFilter: (filterId: string, filterType: SearchFacetType) => void;
  title?: string;
};

const AppliedFilters = ({
  clearAllFilters,
  filters,
  onClearFilter,
  title,
}: Props) => {
  return filters && filters.length > 0 ? (
    <S.AppliedFilters gap={0.5}>
      {!!title && <S.AppliedFiltersTitle>{title}</S.AppliedFiltersTitle>}
      {filters.map(filter => (
        <AppliedFilter
          key={filter.filterId}
          filter={filter}
          onClearFilter={onClearFilter}
        />
      ))}
      <ClearButton clearFilter={clearAllFilters} />
    </S.AppliedFilters>
  ) : null;
};

export default AppliedFilters;
